import styled from 'styled-components'
import Modal from 'react-modal'

export const StyledModal = styled(Modal)`
  position: absolute;
  inset: 40px;
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  border-radius: 10px;
  outline: none;
  max-width: 800px;
  margin: auto;
  max-height: 675px;
  overflow-x: hidden;
  @media (max-width: 762px) {
    position: relative;
    inset: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    background-color: #f2f2f2;
  }
  &.visible {
    max-height: 400px;
  }
  &.hidden {
    max-height: 675px;
  }
`
export const IframePlace = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-y: hidden;
  overflow-x: hidden;
  @media (max-width: 762px) {
    padding-top: 10px;
  }

  &.visible {
    display: flex;
  }

  &.hidden {
    display: none;
  }
`
export const LoaderPlace = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-height: 600px;
  &.visible {
    display: flex;
  }
  &.hidden {
    display: none;
  }
`

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 630px;
  border: none;
  @media (max-width: 762px) {
    height: 910px;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 40px;
  padding-left: 10px;
  @media (max-width: 762px) {
    padding-top: 100px;
  }
`

export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`
